export const shouldForwardProp = <CustomProps>(
    props: Array<keyof CustomProps>,
    prop: PropertyKey
): boolean => !props.includes(prop as keyof CustomProps)
